import Avatar from './components/Avatar';
import React, { useEffect, useState } from 'react';

const ClansInfo = ({ fetchUserData, clanId, onBack, setClan, setUserClanID, setClanTag, clan, userId, setCurrentPage, triggerToast, username}) => {
  const [isMember, setIsMember] = useState(false);
  const [isLeader, setIsLeader] = useState(false);
  const [selectedClanBonus, setSelectedClanBonus] = useState(0); // Бонус выбранного клана
  const [loading, setLoading] = useState(true); 


  const handleKickMember = async (memberId) => {
    if (!window.confirm("Вы уверены, что хотите исключить этого участника?")) {
      return;
    }
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/clans/kick`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ targetUserId: memberId }),
      });
  
      if (response.ok) {
        const updatedClan = await response.json();
        setClan(updatedClan);
        triggerToast('Участник был успешно исключен.');
      } else {
        const { error } = await response.json();
        triggerToast(error || 'Ошибка исключения участника.');
      }
    } catch (error) {
      console.error('Ошибка исключения участника:', error);
      triggerToast('Ошибка при попытке исключения участника.');
    }
  };
  useEffect(() => {
    const fetchClanData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/clans/${clanId}`);
        if (!response.ok) throw new Error('Ошибка загрузки данных о клане');

        const data = await response.json();
        setClan(data);

        const member = data.members.find((member) => String(member.user_id) === String(userId));
        setIsMember(!!member);
        if (member) setIsLeader(member.clan_role === 'leader');
        setLoading(false);
      } catch (error) {
        console.error('Ошибка загрузки данных о клане:', error);
        setClan(null);
        setLoading(false);
      }
    };
    const fetchClanBonus = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/clans/top/fulltop`);
        if (!response.ok) throw new Error("Ошибка загрузки топа кланов");

        const data = await response.json();
        const selectedClanPosition = data.findIndex((clan) => String(clan.id) === String(clanId)) + 1; // Позиция выбранного клана
        const calculatedBonus = selectedClanPosition > 0 ? Math.max(100 - (selectedClanPosition - 1) * 5, 0) : 0;
        setSelectedClanBonus(calculatedBonus);
      } catch (error) {
        console.error("Ошибка при вычислении бонуса выбранного клана:", error);
      }
    };
  


    if (clanId) {
      fetchClanData();
      fetchClanBonus();
    }
  }, [clanId, userId, setClan]);

  const handleJoinClan = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/clans/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clanId, userId }),
      });

      if (response.ok) {
        triggerToast('Вы вступили в клан!');
        const updatedClan = await response.json();
        setClan(updatedClan);
        setIsMember(true);
        fetchUserData(username);
      } else {
        const { error } = await response.json();
        triggerToast(error || 'Ошибка при вступлении в клан.');
      }
    } catch (error) {
      console.error('Ошибка вступления в клан:', error);
    }
  };



  const handleLeaveClan = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/clans/leave`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clanId, userId }),
      });
  
      if (response.ok) {
        triggerToast('Вы покинули клан!');
        setIsMember(false);
        setIsLeader(false);
        setClan(null);
        setUserClanID(null);
        setClanTag(null);
        await fetchUserData(username);
        setCurrentPage('profile');
      } else {
        const data = await response.json().catch(() => ({}));
        triggerToast(data.error || 'Не удалось покинуть клан.');
      }
    } catch (error) {
      console.error('Ошибка выхода из клана:', error);
    }
  };
  

  if (loading) return <div className="container_ clan-page"><p>Загружаем клан…</p></div>;
  if (!clan) return <div className="container_ clan-page"><p>Не удалось загрузить клан.</p><button className="back-btn" onClick={onBack}>Назад</button></div>;
  const sortedMembers = clan.members ? [...clan.members].sort((a, b) => b.clicks - a.clicks) : [];


  return (
<div className="container_ clan-page">
  <div className="clan-header">
    <Avatar clanId={clan.id}
      className="clan-avatar"
      src={clan.avatar_url || '/assets/imgur/aZiYWdZ.png'}
      alt="Clan Avatar"
      onError={(e) => (e.target.src = '/assets/imgur/aZiYWdZ.png')} />
    <div className="clan-info">
      <h1 className="clan-name">{clan.name}</h1>
      <p className="clan-members">{clan.member_count}/20 участников</p>
      <div className="clan-description">
    <p><span className="trophy">🏆</span> {Number(clan.total_clicks).toLocaleString('ru-RU')}</p>
  </div>
    </div>
  </div>
  <hr></hr>
  <div className="clan-description">
    <p>{clan.description || 'Описание отсутствует'}</p>
  </div>
  <hr></hr>
  <div className="clan-description">
    <p>Тэг: #{clan.tag}</p>
  </div>
  {isMember ? (
    <>
<div className="clan-bonuses">
    <h3>Вместе сильнее</h3>
    <div className="bonus-card">
      <p>Получайте бонус к кликам за место в топе!</p>
      <span className="bonus-detail"> + {selectedClanBonus}% к кликам</span>
    </div>
    <div className="bonus-card">
      <p>Сражайтесь с боссом за уникальные награды</p>
      {isMember ? (
      <button onClick={() => setCurrentPage('boss')} className="battle-btn">
        В бой!
      </button>
          ) : (<div/>)}
    </div>
    <div className="bonus-card">
  <p>Участвуйте в клановых битвах за репутацию клана</p>
  {isMember ? (
    <>
      <button 
  className="battle-btn"
  onClick={() => setCurrentPage('clan_wars')}
>
  Клановые войны
</button>

    </>
  ) : (
    <div>Вступите в клан, чтобы участвовать в битвах</div>
  )}
</div>
</div>

    </>
  ) : (
    <div></div>
  )}
    <div className="clan-actions">
    {!isMember ? (
      <button onClick={handleJoinClan} className="action-btn join-btn">
        Вступить в клан
      </button>
    ) : (
      <>
        <button onClick={handleLeaveClan} className="action-btn leave-btn">
          Выйти из клана
        </button>
        {isLeader && (
          <div/>
        )}
      </>
    )}
    <button onClick={onBack} className="back-btn">
      Назад
    </button>
  </div>

  <div className="clan-members-list">
  <h3>Список участников</h3>
  {sortedMembers.length > 0 ? (
    <table className="leaderboard-pi">
      <tbody>
        {(sortedMembers || []).map((member, index) => (
          <tr key={member.user_id} className="leaderboard-ro">
            <td className="leaderboard-ce">
              <div className="member-avatar">
                <Avatar userId={member.user_id} src={member.avatar_url} />
              </div>
              <div className="member-info">
                <span className="member-name">
                  {member.name}
                  {member.clan_role === 'leader' && ' 👑'}
                </span>
                <span className="member-stats">{Number(member.clicks).toLocaleString('ru-RU')} кликов</span>
                {isLeader && (
                  <button
  className="kick-btn"
  onClick={() => handleKickMember(member.user_id)}
>
  X
</button>
              )}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  ) : (
    <p>У клана пока нет участников.</p>
  )}
</div>
</div>
  );
};

export default ClansInfo;
